import { render, staticRenderFns } from "./CellRendererAvatar.vue?vue&type=template&id=070e0d06&"
import script from "./CellRendererAvatar.vue?vue&type=script&lang=ts&"
export * from "./CellRendererAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports